export default "__VITE_ASSET__CXN9c6Nv__"